import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function ClearIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M6.12283 7.05872C6.08904 6.48434 6.54573 6 7.1211 6H16.8789C17.4543 6 17.911 6.48434 17.8772 7.05872L17.1125 20.0587C17.0814 20.5873 16.6437 21 16.1142 21H7.88581C7.35633 21 6.91863 20.5873 6.88754 20.0587L6.12283 7.05872Z" fill={props.fill} stroke={props.fill} strokeWidth="2" />
			<rect x="3" y="5" width="18" height="2" rx="1" fill={props.fill} />
			<rect x="15" y="9" width="7" height="2" rx="1" transform="rotate(90 15 9)" fill="white" />
			<rect x="10" y="2" width="4" height="2" rx="1" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<ClearIcon fill={props.fill} />
		</div>
	);
}